'use client'

import classNames from 'classnames'
import React, { useEffect, useRef } from 'react'
import {
  useHeaderContext,
  DesktopStateActionType,
} from '@dustin-web/microsite-baselayout/src/components/header/header-context'
type Props = {
  type: string
  children: React.ReactNode
}

const MegaMenu = ({ type, children }: Props) => {
  const { desktop, dispatchDesktop } = useHeaderContext()
  const isActive = desktop.activeMegaMenu === type
  const megaMenuRef = useRef<HTMLDivElement | null>(null)

  // Close mega menu on outside click except if that click occurs on a mega-menu-trigger
  useEffect(() => {
    const handleClickOutside = (event: any) => {
      const isClickOutside =
        !!megaMenuRef.current &&
        !megaMenuRef.current.contains(event.target) &&
        !event.target.classList.contains('js-mega-menu-trigger')

      if (isClickOutside) {
        dispatchDesktop({
          type: DesktopStateActionType.SET_ACTIVE_MEGA_MENU,
          payload: {
            activeMegaMenu: '',
          },
        })
      }
    }
    document.addEventListener('click', handleClickOutside)
    return () => {
      document.removeEventListener('click', handleClickOutside)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // We want to load top categories server side for SEO purposes
  if (!isActive && type !== 'category') {
    return null
  }

  return (
    <div
      ref={megaMenuRef}
      className={classNames('c-header__mega-menu', {
        'c-header__mega-menu--auto-height': type === 'brand' || type === 'solutions',
        'd-none': !isActive,
      })}>
      {children}
    </div>
  )
}

export default MegaMenu
